import { FC } from 'react';
import { MenuItemIconStyled, MenuItemLabelStyled, SidebarMenuItemContainerStyled } from './SidebarMenuItem.styles';
import { SidebarMenuItemProps } from './SidebarMenuItem.types';

const SidebarMenuItem: FC<SidebarMenuItemProps> = ({ icon, id, isOpen, isSelected, label, onClick }) => {
  return (
    <SidebarMenuItemContainerStyled
      data-testid={`sidebar-menu-item-${id}`}
      key={id}
      selected={isSelected}
      onClick={onClick}
    >
      <MenuItemIconStyled>{icon}</MenuItemIconStyled>
      <MenuItemLabelStyled isOpen={isOpen} role="label">
        {label}
      </MenuItemLabelStyled>
    </SidebarMenuItemContainerStyled>
  );
};

export default SidebarMenuItem;
